var analytics = (function( $ ) {

	var client_id;

	var _load = function() {
		ga( function( tracker ) {
			var trackers = (window[ window.GoogleAnalyticsObject ]).getAll();
			trackers.forEach( function( tracker ) {
				if ( tracker ) {
					client_id = tracker.get( 'clientId' );

					// Cookie gets set by tag to persist campaign data on GTM
					var campaign_url = $.cookie( '__gtm_campaign_url' );

					$( '#crate-ga-client-id' ).val( client_id );
					$( '#crate-ga-campaign-url' ).val( campaign_url );
				}
			} );
		} );
	};

	var get_client_id = function() {
		return client_id;
	};

	$( window ).load( _load );

	return {
		get_client_id: get_client_id
	};

})( jQuery );

module.exports = analytics;